module.exports = __webpack_public_path__ + "static/media/NL.4daecacb.svg";